import { render } from "./IntegrationExpiredBanner.vue?vue&type=template&id=229540e7&scoped=true"
import script from "./IntegrationExpiredBanner.vue?vue&type=script&lang=js"
export * from "./IntegrationExpiredBanner.vue?vue&type=script&lang=js"

import "./IntegrationExpiredBanner.vue?vue&type=style&index=0&id=229540e7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-229540e7"]])

export default __exports__